import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { IDevice, IKioskRegistration } from '../../models/device.interface';
import { EMessageType } from '../../../../shared/data/response-default.interface';
import { interceptorAvisouErro } from '../../../../shared/http-interceptor/http-interceptor.module';
import { ERoleAdminString } from '../../../../shared/data/role.enum';
import { DeviceService } from '../../services/device.service';
import { ToastService } from '../../../../shared/services/toast.service';
import { ModalConfirmacaoService } from '../../../../shared/services/modal-confirmacao.service';

@Component({
  selector: 'app-list-devices',
  templateUrl: './list-devices.component.html',
  styleUrls: ['./list-devices.component.scss']
})
export class ListDevicesComponent implements OnDestroy {
  ERoleAdminString = ERoleAdminString;
  private readonly destroy$ = new Subject<void>();
  @Input() devices: IDevice[] = [];
  @Input() kioskRegistrations: Record<string, IKioskRegistration> = {};
  @Output() mudouTamanhoPagina = new EventEmitter<number>();
  @Output() mudouPagina = new EventEmitter<number>();
  @Output() recarregarListagem = new EventEmitter();
  @Input() dadosPaginacao: {
    paginaSelecionada: number;
    tamanhoPagina: number;
    totalPaginas: number;
    itensTotal: number;
  } = {
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };

  constructor(
    private readonly deviceService: DeviceService,
    private readonly toastService: ToastService,
    private readonly modalConfirmacao: ModalConfirmacaoService
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public toogleDeviceStatus(deviceId: string, status: boolean): void {
    const textoStatus = status ? 'desativar' : 'ativar';
    const operacao$ = status ? this.deviceService.desativarDevice(deviceId) : this.deviceService.ativarDevice(deviceId);

    this.modalConfirmacao
      .abrirModalConfirmacao({ mensagem: `Tem certeza que deseja ${textoStatus} o dispositivo?` })
      .pipe(
        takeUntil(this.destroy$),
        filter(Boolean),
        switchMap(() => operacao$)
      )
      .subscribe((resposta) => {
        if (resposta.messages && resposta.messages.length > 0) {
          this.toastService.toast(resposta.messages);
        }
        if (resposta.isSucceed) {
          this.recarregarListagem.emit();
        }
      });
  }

  public revokeKioskRegistration(device: IDevice): void {
    this.modalConfirmacao
      .abrirModalConfirmacao({
        mensagem: `Revogar o registro do totem ${device.name}? O totem para de funcionar até ser configurado de novo.`
      })
      .pipe(
        takeUntil(this.destroy$),
        filter(Boolean),
        switchMap(() => this.deviceService.revokeKioskRegistration(device.id))
      )
      .subscribe({
        next: (resposta) => {
          if (resposta.messages && resposta.messages.length > 0) {
            this.toastService.toast(resposta.messages);
          }
          if (resposta.isSucceed) {
            this.recarregarListagem.emit();
          }
        },
        error: (erro) => {
          if (!interceptorAvisouErro(erro)) {
            this.toastService.toast('Não foi possível revogar o registro do totem.', EMessageType.Error);
          }
        }
      });
  }
}
